var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1aa1c8ee6de3b0dfe8483f0633fc2fa09d42d47d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["payex-web@flywire"]={id:"1aa1c8ee6de3b0dfe8483f0633fc2fa09d42d47d"};
      